export const white = '#FFF';
export const black = '#000';

export const gray000 = '#f8f8f8';
export const gray50 = gray000;
export const gray100 = gray000;
export const gray200 = '#efefef';
export const gray300 = '#e5e5e5';
export const gray400 = '#d7d7d7';
export const gray500 = '#cacaca';
export const gray600 = '#a2a2a2';
export const gray700 = '#666666';
export const gray800 = '#3a3a3a';
export const gray900 = '#1a1a1a';

export const red000 = '#fff3f4';
export const red50 = red000;
export const red100 = red000;
export const red200 = '#ffb8bc';
export const red300 = '#ff8087';
export const red400 = '#ff5e66';
export const red500 = '#fd3049';
export const red600 = '#f3213b';
export const red700 = '#e7052e';
export const red800 = '#d40429';
export const red900 = '#c10123';
export const redError = '#ff5252';

export const pinkRed000 = red000;
export const pinkRed50 = red50;
export const pinkRed100 = red100;
export const pinkRed200 = red200;
export const pinkRed300 = red300;
export const pinkRed400 = red400;
export const pinkRed500 = red500;
export const pinkRed600 = red600;
export const pinkRed700 = red700;
export const pinkRed800 = red800;
export const pinkRed900 = red900;

export const orange000 = '#fff2e9';
export const orange50 = orange000;
export const orange100 = orange000;
export const orange200 = '#ffb894';
export const orange300 = '#ff9a67';
export const orange400 = '#ff722a';
export const orange500 = '#ff5600';
export const orange600 = '#ff3d00';
export const orange700 = '#f63105';
export const orange800 = '#e92a00';
export const orange900 = '#e92a00';

export const magenta100 = '#fff3f9';
export const magenta200 = '#ffb8dd';
export const magenta300 = '#ff83c6';
export const magenta400 = '#f558ad';
export const magenta500 = '#ec0d85';
export const magenta600 = '#ca006d';
export const magenta700 = '#b30262';
export const magenta800 = '#a10359';
export const magenta900 = '#90004e';

export const yellow100 = '#fffbe4';
export const yellow200 = '#fde671';
export const yellow300 = '#ffe452';
export const yellow400 = '#ffdd29';
export const yellow500 = '#ffd600';
export const yellow600 = '#ffb800';
export const yellow700 = '#ffaa04';
export const yellow800 = '#ff9900';
export const yellow900 = '#ff8a00';

export const violetBlue100 = '#f5f7ff';
export const violetBlue200 = '#cad5ff';
export const violetBlue300 = '#a5b9ff';
export const violetBlue400 = '#7c98ff';
export const violetBlue500 = '#5f82ff';
export const violetBlue600 = '#4971ff';
export const violetBlue700 = '#3360ff';
export const violetBlue800 = '#1d4efa';
export const violetBlue900 = '#0031dd';

export const blue000 = '#ebf6ff';
export const blue100 = blue000;
export const blue200 = '#b4dafd';
export const blue300 = '#93ccff';
export const blue400 = '#74bdff';
export const blue500 = '#2897fb';
export const blue600 = '#0369e0';
export const blue700 = '#004ec3';
export const blue800 = '#0043a8';
export const blue900 = '#003b93';

export const aquaGreen100 = '#e5fdff';
export const aquaGreen200 = '#94edf2';
export const aquaGreen300 = '#6ce5ec';
export const aquaGreen400 = '#42dfe8';
export const aquaGreen500 = '#08c4d1';
export const aquaGreen600 = '#01a7b1';
export const aquaGreen700 = '#00969f';
export const aquaGreen800 = '#008189';
export const aquaGreen900 = '#006d74';

export const seaGreen100 = '#e3fffb';
export const seaGreen200 = '#7ff1e2';
export const seaGreen300 = '#59e8d4';
export const seaGreen400 = '#00d4b6';
export const seaGreen500 = '#00b79d';
export const seaGreen600 = '#008976';
export const seaGreen700 = '#007362';
export const seaGreen800 = '#005f52';
export const seaGreen900 = '#004e43';

export const green100 = '#e9ffea';
export const green200 = '#87f1a5';
export const green300 = '#5ce884';
export const green400 = '#26dd5a';
export const green500 = '#06d03f';
export const green600 = '#00b031';
export const green700 = '#009e2c';
export const green800 = '#008c27';
export const green900 = '#007521';
